// extracted by mini-css-extract-plugin
export var body = "styles-module--body--Bi3vW";
export var close = "styles-module--close--2oyk1";
export var descriptionEvent = "styles-module--descriptionEvent--qxYaH";
export var eventContainer = "styles-module--eventContainer--T0PYb";
export var image = "styles-module--image--+eKlI";
export var modal = "styles-module--modal--WaGjy";
export var title = "styles-module--title--Qi8+0";
export var titleAtelier = "styles-module--titleAtelier--c-mhb";
export var whenWhere = "styles-module--whenWhere--nwTcu";
export var whenWhereContent = "styles-module--whenWhereContent--F+O-A";
export var whenWhereTitle = "styles-module--whenWhereTitle--w4G53";